import { DISALLOWED_IP_LIST } from '@/core/config/apiKey'

export const checkIpForAllowed = (value: string) => {
  if (DISALLOWED_IP_LIST.includes(value)) return false
  return true
}
